'use client';

import type {ReactNode} from 'react';

import {ThemeProvider as NextThemesProvider} from 'next-themes';


interface Props {
    children: ReactNode;
}

export const ThemeProvider = ({children}: Props) => (
    <NextThemesProvider
        attribute="class"
        defaultTheme="dark"
        enableSystem
        storageKey="theme-preference"
        disableTransitionOnChange={false}
    >
        {children}
    </NextThemesProvider>
)
